<div class="cancel-dialog">
  <h2 class="cancel-dialog__header">Cancelar inversión</h2>

  <p class="cancel-dialog__body-text">
    Al continuar la inversión quedará cancelada y el monto volverá al dinero disponible
  </p>

  <div class="cancel-dialog__warning">
    <p class="cancel-dialog__warning-text">
      Recuerda que el inversionista seguirá viendo la inversión pero con estado cancelado.
    </p>
  </div>

  <div class="cancel-dialog__actions">
    <button class="cancel-dialog__actions-button--cancel" (click)="cancel()">Volver</button>
    <fs-ui-button [type]="'secondary'" [label]="'Cancelar inversión'" (click)="confirmCancellation()"></fs-ui-button>
  </div>
</div>
